import {getLocal, setLocal} from "../../common/functions/storage";
import {MULTILEVEL} from "../../common/constant";

const initialState = {
    isAuthenticated: false,
    socketId: '',
    token: '',
    _id: '',
    user_id: '',
    firstName: '',
    lastName: '',
    fullName: '',
    email: '',
    S3_BASE_URL: '',
    orgId: '',
    planAccess: {},
    fileSizeLimit: 3,
    error: null,
    pdfFileLimit: 25,
    addMember: '',
    isAdmin: false,
    platformAccess: {CHAT: ['WEB']},
    files: {},
    workSpaces: [],
    filterData: {},
    productVideo:{},
    clearCache: {},
    holidayStartAndEndYear: {
        startYear: '',
        endYear: ''
    },
    assetCategoryList: [],
    assetConditionList: [],
    legalEntityCompanyId: '',
    companyLogo: {},
    activeLeaveType: '',
    currentOrg: null,
    payrollAdditionalDeduction: {},
    payrollRebate: {},
    payrollESIC: {
        isActive: false,
        isEmployerCountCTC: false
    },
    payrollPF: {
        isActive: false,
        "isEmployerAdminCharge": false,
        "isEmployerEDLIContribution": false,
        "isOverridePFContribution": false,
        "isLopProRate": false,
        "isLopAllApplicable": false,
        isEmployerContributionCTC: false,
        employerContribution: {},
        employeeContribution: {}
    },
    attendanceMulti: [],
    ffMulti: [],
    leaveMulti: [''],
    encashmentMulti: [],
    expenseMulti: [],
    taxRegimeMulti: [],
    bonusDeductionMulti: [],
    shiftMulti: [''],
    otMulti: [],
    orMulti: [],
    compOffMulti: [],
    employeeExitMulti: [],
    employeeExitTaskList: [],
    employeeOnDutyMulti: [''],
    notificationCount: 0,
    missingAttendanceCount: 0,
    isNotificationPopup: false,
    activeNotificationTab: 'all',
    globalNotificationList: [],
    globalNotificationPopupList: [],
    myTimer: null,
    inviteModal: false,
    repeatedSurveyModal: {
        flag: false,
        id: ''
    },
    requestModalData:[],
    jobView: getLocal('u_pv') ? getLocal('u_pv') : 'grid',
    isInActiveEmployees : false,
    profileUpdateSelect: [],
    location: {
        lat: 0,
        lng: 0,
        address: "",
        permission: "",
        mocked: false
    },
};

export default function (state = initialState, action) {
    switch (action.type) {
        case 'SOCKET_CONNECTION': {
            const localState = {socketId: action.payload}
            if (!action.payload) localState.isAuthenticated = false
            return {...state, ...localState};
        }
        case 'ON_BOARDING_AUTHENTICATE': {
            const data = {}
            if (action.payload) {
                data.token = action.payload.token
                data._id = action.payload._id
                data.firstName = action.payload.firstName
                data.lastName = action.payload.lastName
                data.email = action.payload.email
                data.S3_BASE_URL = action.payload.S3_BASEURL
                data.fullName = `${action.payload.firstName} ${action.payload.lastName}`
                data.orgId = action.payload.orgId
                data.image = action?.payload?.profileImage
                data.isAdmin = action?.payload?.isAdmin
                data.jobTitle = action?.payload?.jobTitle
                data.maxFileSizeLimit = action?.payload?.maxFileSizeLimit ? Number(Number(action?.payload?.maxFileSizeLimit) / 1024 / 1024) : 25
                data._user = {
                    label: `${action.payload.firstName} ${action.payload.lastName}`,
                    name: `${action.payload.firstName} ${action.payload.lastName}`,
                    value: action.payload._id,
                    _id: action.payload._id,
                    profileImage: action?.payload?.profileImage
                }
            }
            return {...state, ...data};
        }
        case 'AUTHENTICATE': {
            const data = {isAuthenticated: !!action.payload}
            if (action.payload) {
                data.token = action.payload.token
                data._id = action.payload._id
                data.user_id = action.payload.user_id
                data.firstName = action.payload.firstName
                data.lastName = action.payload.lastName
                data.email = action.payload.email
                data.S3_BASE_URL = action.payload.S3_BASEURL
                data.fullName = `${action.payload.firstName} ${action.payload.lastName}`
                data.orgId = action.payload.orgId
                data.image = action?.payload?.profileImage
                data.isAdmin = action?.payload?.isAdmin
                data.jobTitle = action?.payload?.jobTitle
                data.platformAccess = action?.payload?.platformAccess
                data.settings = {
                    ...(action?.payload?.settings || {}),
                    maxFileSizeLimit: action?.payload?.settings?.maxFileSizeLimit ? Number(Number(action?.payload?.settings?.maxFileSizeLimit) / 1024 / 1024) : 25
                }
                data._user = {
                    label: `${action.payload.firstName} ${action.payload.lastName}`,
                    name: `${action.payload.firstName} ${action.payload.lastName}`,
                    value: action.payload._id,
                    _id: action.payload._id,
                    profileImage: action?.payload?.profileImage
                }
                data.planAccess = action.payload.planAccess
            }
            return {...state, ...data};
        }
        case 'SET_ERROR': {
            return {...state, error: action.payload}
        }
        case 'SET_WORK_DIARY_AUTH_RESPONSE': {
            const data = {
                settings: {
                    ...(state?.settings || {}),
                    isWorkDiaryUser: action?.payload?.isWorkDiaryUser ?? false
                }
            }
            return {...state, ...data};
        }
        case 'UPDATE_MASTER_DATA': {
            const data = {}
            if (action.payload?.userInfo?.contactId === state._id) {
                const info = action.payload?.userInfo
                data.firstName = info.firstName
                data.lastName = info.lastName
                data.fullName = `${info.firstName} ${info.lastName}`
                data.image = info?.profileImage
                data._user = {
                    label: `${info.firstName} ${info.lastName}`,
                    value: info._id,
                    profileImage: info?.profileImage
                }
            }
            return {...state, ...data,};
        }
        case 'UPDATE_MASTER_SETTINGS': {
            const settings = JSON.parse(JSON.stringify(state.settings))

            if (action.payload?.employeeCodePostfix) {
                settings.employeeCodePostfix = action.payload?.employeeCodePostfix
            } if (action?.payload?.setting?.hasOwnProperty('isTaskDescriptionRequired')) {
                settings.isTaskDescriptionRequired = action.payload?.setting?.isTaskDescriptionRequired
            } if (action?.payload?.setting?.hasOwnProperty('isTaskActivityRequired')) {
                settings.isTaskActivityRequired = action.payload?.setting?.isTaskActivityRequired
            } else if (action?.payload?.hasOwnProperty('isWorkDiaryUser')) {
                settings.isWorkDiaryUser = action.payload?.isWorkDiaryUser ?? false
            }

            return {...state, settings};
        }
        case 'ADD_MEMBER_SIDEBAR': {
            return {...state, addMember: action.payload};
        }
        case 'GET_LANGUAGE_STATUS': {
            return {
                ...state,
                languagePayload: action.payload
            };
        }
        case 'GET_FAMILY_RELATION': {
            return {
                ...state,
                familyPayload: action.payload
            };
        }
        case 'MULTI_FILTER_DATA_RESIGNATION': {
            return {
                ...state,
                filterResignation: action.payload
            };
        }
        case 'SEARCH_RESIGNATION_DATA': {
            return {
                ...state,
                resignationSearch: action.payload
            };
        }
        case 'DATE_AGREEMENT_FILTER': {
            return {
                ...state,
                dateAgreementFilter: action.payload
            };
        }

        case 'DATE_FILTER': {
            return {
                ...state,
                dateFilter: action.payload
            };
        }
        case 'GROUP_FILTER_DATA': {
            return {
                ...state,
                groupBy: action.payload
            };
        }
        case 'UPLOAD_FILES': {
            return {
                ...state,
                imageUpload: action.payload
            };
        }
        case 'SET_WORKSPACE_LIST': {
            const localState = {};
            if (action.payload?.length) {
                localState.workSpaces = action.payload;
                localState.currentOrg = action.payload.find(e => e.orgId === state.orgId);
            }

            return {...state, ...localState};
        }
        case 'UPDATE_PLATFORM_ACCESS': {
            const localState = {};
            if (action.payload?.platformAccess) {
                localState.platformAccess = action.payload?.platformAccess;
            }
            return {...state, ...localState};
        }
        case 'UPLOAD_PROFILE': {
            return {
                ...state,
                uploadProfile: action.payload?.userInfo
            };
        }
        case 'GET_ASSET_DETAILS': {
            return {...state,
                assetCategoryList: action?.payload?.assetCategorList,
                assetConditionList: action?.payload?.assetConditionList
            }
        }
        case 'SET_RAW_FILES' : {
            let rawFiles = Object.assign({}, state.rawFiles);
            if (action.payload.file) rawFiles[action.payload.id] = action.payload;
            else delete rawFiles[action.payload.id];
            return {...state, rawFiles};
        }
        case 'CLOSE_RELEASENOTE_POPUP':
            return {...state, release: {...state.release, displayReleaseNotification: action.payload}};
        case 'CLEAR_CACHE_POPUP':
            return {...state, clearCache: action.payload};
        case 'SET_PRODUCT_VIDEO':
            return {...state, productVideo: action.payload.hrms};
        case 'SET_UAC_UPDATE':
            return {...state, uacUpdate: action.payload};
        case 'COMPANY_LOGO':
            return {...state, companyLogo: action.payload};

        case 'SET_HOLIDAY_START_END_YEAR': {
            return {...state, holidayStartAndEndYear: {...state.holidayStartAndEndYear, ...action.payload}};
        }
        case 'SET_ACTIVE_LEAVE_TYPE': {
            return {...state, activeLeaveType: action.payload}
        }
        case 'SET_PAYROLL_ADDITIONAL_DEDUCTION': {
            return {...state, payrollAdditionalDeduction: {...state.payrollAdditionalDeduction, ...action.payload}}
        }
        case 'SET_PAYROLL_REBATE': {
            return {...state, payrollRebate: {...state.payrollRebate, ...action.payload}}
        }
        case 'SET_PAYROLL_ESIC': {
            return {...state, payrollESIC: {...state.payrollESIC, ...action.payload}}
        }
        case 'SET_PAYROLL_PF': {
            return {...state, payrollPF: {...state.payrollPF, ...action.payload}}
        }
        case 'SET_INBOX_ATTENDANCE_MULTI_SELECTED': {
            return {...state, attendanceMulti: action.payload}
        }
        case 'SET_INBOX_LEAVE_MULTI_SELECTED': {
            return {...state, leaveMulti: action.payload}
        }
        case 'SET_INBOX_ENCASHMENT_MULTI_SELECTED': {
            return {...state, encashmentMulti: action.payload}
        }
        case 'SET_INBOX_EXPENSE_MULTI_SELECTED': {
            return {...state, expenseMulti: action.payload}
        }
        case 'SET_INBOX_TAX_REGIME_MULTI_SELECTED': {
            return {...state, taxRegimeMulti: action.payload}
        }
        case 'SET_INBOX_BONUS_DEDUCTION_MULTI_SELECTED': {
            return {...state, bonusDeductionMulti: action.payload}
        }
        case 'SET_INBOX_SHIFT_MULTI_SELECTED': {
            return {...state, shiftMulti: action.payload}
        }
        case 'SET_INBOX_ASSET_MULTI_SELECTED': {
            return {...state, assetMulti: action.payload}
        }
        case 'SET_INBOX_HOLIDAY_MULTI_SELECTED': {
            return {...state, holidayMulti: action.payload}
        }
        case 'SET_INBOX_OT_MULTI_SELECTED': {
            return {...state, otMulti: action.payload}
        }
        case 'SET_INBOX_OR_MULTI_SELECTED': {
            return {...state, orMulti: action.payload}
        }
        case 'SET_INBOX_CO_MULTI_SELECTED': {
            return {...state, compOffMulti: action.payload}
        }
        case 'SET_INBOX_FF_MULTI_SELECTED': {
            return {...state, ffMulti: action.payload}
        }
        case 'SET_INBOX_EMPLOYEE_EXIT_MULTI_SELECTED': {
            return {...state, employeeExitMulti: action.payload}
        }
        case 'SET_INBOX_EMPLOYEE_EXIT_TASK_LIST': {
            return {...state, employeeExitTaskList: action.payload}
        }
        case 'SET_INBOX_EMPLOYEE-ONDUTY_SELECTED': {
            return {...state, employeeOnDutyMulti: action.payload}
        }
        case 'SET_FILES': {
            return {...state, files: action.payload};
        }
        case 'NOTIFICATION_COUNT': {
            return {...state, notificationCount: action.payload}
        }
        case 'MISSING_ATTENDANCE_COUNT': {
            return {...state, missingAttendanceCount: action.payload}
        }
        case 'UPDATE_GLOBAL_NOTIFICATION_POPUP_FLAG': {
            return {...state, isNotificationPopup: action.payload}
        }
        case 'UPDATE_NOTIFICATION_TAB': {
            return {...state, activeNotificationTab: action?.payload}
        }
        case 'GLOBAL_NOTIFICATION_LIST': {
            let allList = JSON.parse(JSON.stringify(state.globalNotificationList));
            let popupList = JSON.parse(JSON.stringify(state.globalNotificationPopupList));
            let isPopup = state.isNotificationPopup

            if (action?.payload && action?.payload?.isPopup) {
                isPopup = action?.payload?.isPopup
                popupList = action?.payload?.result[0].result
            } else if (action?.payload && action?.payload?.currentPage !== 1) {
                action?.payload?.list?.length !== 0 && allList.push(...action?.payload?.list)
            } else {
                allList = action?.payload?.list
            }

            return {
                ...state,
                globalNotificationList: allList,
                globalNotificationPopupList: popupList,
                isNotificationPopup: isPopup
            }
        }
        case 'UPDATE_GLOBAL_NOTIFICATION_LIST': {
            let allList = JSON.parse(JSON.stringify(state.globalNotificationList));
            let popupList = JSON.parse(JSON.stringify(state.globalNotificationPopupList));

            if (action?.payload && !action?.payload?.isReadAll) {
                if (action?.payload?.isPopup && action?.payload?.activityTab && state?.activeNotificationTab === "all") {
                    allList.map(e => {
                        if (e?._id === action?.payload?.readNotification?._id) {
                            e.isRead = true
                        }
                        return e
                    })
                    if (action?.payload?.activityTab === 'all') {
                        popupList.map(e => {
                            if (e?._id === action?.payload?.readNotification?._id) {
                                e.isRead = true
                            }
                            return e
                        })
                    } else {
                        popupList = popupList.filter(e => e?._id !== action?.payload?.readNotification?._id)
                    }
                } else if (action?.payload?.isPopup && action?.payload?.activityTab && state?.activeNotificationTab === "unread") {
                    allList = allList.filter(e => e?._id !== action?.payload?.readNotification?._id)
                    if (action?.payload?.activityTab === 'all') {
                        popupList.map(e => {
                            if (e?._id === action?.payload?.readNotification?._id) {
                                e.isRead = true
                            }
                            return e
                        })
                    } else {
                        popupList = popupList.filter(e => e?._id !== action?.payload?.readNotification?._id)
                    }
                } else if (action?.payload?.activityTab && state?.activeNotificationTab === "all") {
                    allList = allList.map(e => {
                        if (e?._id === action?.payload?.readNotification?._id) {
                            e.isRead = true
                        }
                        return e
                    })
                } else if (action?.payload?.activityTab && state?.activeNotificationTab === "unread") {
                    allList = allList = allList.filter(e => {
                        if (e?._id !== action?.payload?.readNotification?._id) return e
                    })
                } else {
                    /**
                     * this code added for announcement real time notification replace at the place of old
                     * check if exist then remove old notification add new on the top the list
                     */
                    const hasPostItem = (arr) => arr.findIndex(e => {
                        return action.payload.type === e.type && action.payload?.payload?.postId === e?.payload?.postId && action.payload?.payload?.key === e?.payload?.key
                    })
                    allList.splice(hasPostItem(allList), 1)
                    popupList.splice(hasPostItem(popupList), 1)

                    popupList.unshift(action?.payload)
                    allList.unshift(action?.payload)
                }
            } else if (action?.payload?.activityTab === "all") {
                popupList.map(e => e.isRead = true)
            } else if (action?.payload?.activityTab === "unread") {
                popupList = []
            }

            return {...state, globalNotificationList: allList, globalNotificationPopupList: popupList}
        }
        case 'READ_GLOBAL_NOTIFICATION_LIST' : {
            const localState = {}
            if (action?.payload?.isReadAll) {
                if (state.activeNotificationTab === 'unread') {
                    localState.globalNotificationList = []
                } else {
                    let allList = JSON.parse(JSON.stringify(state.globalNotificationList));
                    allList.map(e => {
                        e.isRead = true
                        return e
                    })
                    localState.globalNotificationList = allList
                }
            }

            return {...state, ...localState}
        }
        case 'SET_MY_TIMER': {
            const localState = {}

            if (action?.payload && !action?.payload?.error && !action?.payload?.data?.error) {
                switch (action?.payload?.event) {
                    case 'hrms|pms|activeTimer|start': {
                        if (action?.payload?.data?.user === state?._id) {
                            localState.myTimer = action?.payload?.data
                        }
                        break;
                    }
                    case 'stopTimeTracker': {
                        if (action?.payload?.data?.trackerInfo?.user === state?._id) {
                            localState.myTimer = null
                        }
                        break;
                    }
                    case 'removeTimeTracker': {
                        if (action?.payload?.data?.user === state?._id) {
                            localState.myTimer = null
                        }
                        break;
                    }
                    case 'hrms|dashboard|get': {
                        localState.myTimer = action?.payload?.data
                        break;
                    }
                    default: {
                        localState.myTimer = action.payload
                    }
                }
            }
            return {...state, ...localState}
        }
        case 'SET_INVITE_MODAL': {
            return {...state, inviteModal: action.payload};
        }
        case 'SET_REPEATED_SURVEY_MODAL': {
            return {...state, repeatedSurveyModal: action.payload};
        }
        case 'OPEN_DOC_URL': {
            if (action.payload) window.open(state.S3_BASE_URL + action.payload, '_blank')
            return {...state};
        }
        case 'CHANGE_JOB_VIEW' : {
            setLocal('u_pv', action.payload);
            return {...state, jobView: action.payload};
        }
        case 'SET_MULTILEVEL_DATA' : {
            let localState = JSON.parse(JSON.stringify(state));
            let module = MULTILEVEL?.get(action.payload?.type);

            if(module){
                localState[module] = action.payload?.data;
                return localState;
            }else return localState;
        }

        case 'SET_LEAVE_APPROVAL_REJECT_LEVEL' : {
            let localState = JSON.parse(JSON.stringify(state));
            /**
             * multiLevelLeave : is for when user approve leave we have to send levels and leaveId
             * approveIDs : is when bulk approval this is required
             * ***/
            if(action.payload.type === 'levels_approveID_rejectID'){
                return {...localState,
                        leave:{...localState.leave,
                        multiLevelLeave: [...action.payload?.data?.approvalLevels],
                        approveIDs: [...action.payload?.data?.approveIDs],
                        rejectIDs: [...action.payload?.data?.rejectIDs],}};
            }
            return {...state}
        }
        case 'SET_SHIFT_REQUEST_APPROVAL_REJECT_LEVEL' : {
            let localState = JSON.parse(JSON.stringify(state));
            if(action.payload.type === 'levels_approveID_rejectID'){
                return {...localState,
                    shiftRequest:{...localState.shiftRequest,
                        multiLevelShift: [...action.payload?.data?.approvalLevels],
                        approveIDs: [...action.payload?.data?.approveIDs],
                        rejectIDs: [...action.payload?.data?.rejectIDs],}};
            }
            return {...state}
        }
        case 'USER_REQUEST_DATA' : {
            return {...state, requestModalData: action.payload};
        }
        case 'SET_INACTIVE_EMPLOYEE_FILTER' : {
            return {...state, isInActiveEmployees: action.payload};
        }
        case 'SELECT_PROFILE_REQUEST': {
            return {...state, profileUpdateSelect: [...action?.payload]}
        }
        case 'UPDATE_LOCATION' : {
            return {...state, location: {...state.location, ...action.payload, time: new Date().getTime()}}
        }
        default:
            return state;
    }
}
